<div class="betslip-over-ask-reject-confirm-dialog">
    <div class="betslip-over-ask-reject-confirm-dialog__header"></div>

    @if (isMobile) {
        <div class="betslip-over-ask-reject-confirm-dialog__content--mobile">
            <div class="betslip-over-ask-reject-confirm-dialog-bar"></div>
            <div class="betslip-over-ask-reject-confirm-dialog-info">
                <div class="title-warning">
                    <span class="betslip-over-ask-reject-confirm-dialog__content--title">{{ messages.title }}</span>
                    <div class="warning">
                        <i class="theme-warning"></i>
                    </div>
                </div>
                <p class="betslip-over-ask-reject-confirm-dialog__content--message">{{ messages.content }}</p>
            </div>
        </div>
    } @else {
        <div class="betslip-over-ask-reject-confirm-dialog__content">
            <span class="betslip-over-ask-reject-confirm-dialog__content--title">{{ messages.title }}</span>
            <p class="betslip-over-ask-reject-confirm-dialog__content--message">{{ messages.content }}</p>
        </div>
    }
    <bs-over-ask-accept-timeout *ngIf="vm.isTimerVisible" [seconds]="vm.seconds" [messages]="messages"></bs-over-ask-accept-timeout>
    <div class="betslip-over-ask-reject-confirm-dialog__actions">
        <div class="betslip-over-ask-reject-confirm-dialog__actions--return">
            <button (click)="onReturnBack()">{{ messages.dismiss }}</button>
        </div>
        <div class="betslip-over-ask-reject-confirm-dialog__actions--cancel">
            <button (click)="onCancelConfirm()">{{ messages.cancelOffer }}</button>
        </div>
    </div>
</div>
